module.exports = __webpack_public_path__ + "static/media/image11.a8e6a1e0.jpg";